// extracted by mini-css-extract-plugin
export default {"chartContainer":"BarChartComponent_chartContainer__ghguR","borderContainer":"BarChartComponent_borderContainer__Tpksz","chartBtns":"BarChartComponent_chartBtns__IfAwN"};